import { Link } from "react-router-dom";

const footerNav = [
  { label: "首页", to: "/" },
  { label: "明星资讯", to: "/news" },
  { label: "作品一览", to: "/works" },
  { label: "个人资料", to: "/profile" },
  { label: "粉丝互动", to: "/fan-interaction" },
  { label: "关于本站", to: "/about" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100 mt-16">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-10 rounded-full bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg font-bold">
                优
              </span>
              <span className="font-heading text-lg font-bold">大岛优香 · 明星资讯站</span>
            </div>
            <p className="text-sm leading-relaxed text-background-200 max-w-sm">
              本站为粉丝自建的非官方资讯聚合站，汇集大岛优香的个人资料、影视作品与最新动态，
              内容均为演示示例，仅供参考交流。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold tracking-wider text-background-100 mb-4">
              快速导航
            </h4>
            <ul className="grid grid-cols-2 gap-2">
              {footerNav.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-200 hover:text-primary-200 transition-colors whitespace-nowrap"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold tracking-wider text-background-100 mb-4">
              联系我们
            </h4>
            <ul className="space-y-3 text-sm text-background-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center" />
                contact@oshima-yuka.example
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center" />
                内容合作 · 线上沟通
              </li>
              <li className="flex items-center gap-3 pt-1">
                <span className="w-8 h-8 rounded-full bg-primary-800 flex items-center justify-center">
                  <i className="ri-weibo-fill" />
                </span>
                <span className="w-8 h-8 rounded-full bg-primary-800 flex items-center justify-center">
                  <i className="ri-instagram-line" />
                </span>
                <span className="w-8 h-8 rounded-full bg-primary-800 flex items-center justify-center">
                  <i className="ri-youtube-line" />
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-300">
          <p>© 2026 大岛优香明星资讯站 · 本站内容为演示示例，非官方发布</p>
          <p>明星资料 · 影视作品 · 最新动态 · 粉丝互动</p>
        </div>
      </div>
    </footer>
  );
}